import { render, staticRenderFns } from "./dropdownIcon.vue?vue&type=template&id=57c769c2&scoped=true&"
import script from "./dropdownIcon.vue?vue&type=script&lang=js&"
export * from "./dropdownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c769c2",
  null
  
)

export default component.exports